<div class="container-fluid">
  <!-- Breadcrumb Section -->
  <div class="row">
    <div class="col-md-12">
      <nav
        class="breadcrumb-container d-flex align-items-center justify-content-between mb-2 mt-md-0 mt-4"
      >
        <div class="d-flex align-items-center flex-wrap gap-2">
          <!-- Back Button -->
          <a
            class="back-link d-flex align-items-center justify-content-center me-3"
            routerLink="/applicationlist"
            [title]="'COMMON.BACK' | translate"
          >
            <mat-icon>arrow_back</mat-icon>
          </a>

          <!-- Application Info -->
          <div class="d-flex align-items-center me-2">
            <div
              class="avatar-wrapper position-relative border rounded flex-shrink-0"
              style="width: 36px; height: 36px; overflow: visible"
            >
              <div
                style="width: 100%; height: 100%; overflow: hidden"
                class="rounded"
              >
                <img
                  [src]="getDocThumbnail(form.data['logo'])"
                  class="w-100 h-100"
                  style="object-fit: contain"
                />
              </div>
              <span class="status-indicator"></span>
            </div>

            <div class="ms-3">
              <h6 class="mb-0 text-dark lh-1 text-wrap text-break">
                {{ form.data["name"] }}
              </h6>
            </div>
          </div>
          <!-- Separator -->
          <i class="bx bx-chevron-right text-muted mx-2 opacity-50"></i>
          <!-- Usecase Section -->
          <div class="d-flex align-items-center">
            <h6 class="mb-0 text-dark text-wrap text-break">
              {{ "APPLICATIONS.INFO_TITLE" | translate }}
            </h6>
          </div>
        </div>
      </nav>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mt-3">
      <div class="card shadow-sm">
        <div class="card-header py-3">
          <h5 class="mt-2 mb-0 fw-semibold">
            {{ "ALLREMAININGS.Informations" | translate }}
          </h5>
        </div>
        <div class="card-body">
          <form #uiForm="ngForm" class="compact-inputs dropdown-pd-none">
            <!-- Alert Messages -->
            <p *ngIf="form['error'] === false && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="success"
              ></app-ncs-alert>
            </p>
            <p *ngIf="form['error'] === true && form['message']">
              <app-ncs-alert
                [message]="form['message']"
                type="danger"
              ></app-ncs-alert>
            </p>

            <!-- Name Field -->
            <div class="row mb-3">
              <label for="name" class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.NAME" | translate }}:</label
              >
              <div class="col-md-7">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="name"
                    name="name"
                    type="text"
                    required
                    [(ngModel)]="form.data['name']"
                    [placeholder]="'COMMON.NAME' | translate"
                    (input)="checkValue($event)"
                    [class.is-invalid]="form.inputerror['name']"
                  />
                </mat-form-field>
                <mat-error *ngIf="form.inputerror['name']">
                  {{ form.inputerror["name"] }}
                </mat-error>
              </div>
            </div>

            <div class="row mb-4">
              <label class="col-md-2 col-form-label fw-medium">
                {{ "COMMON.URL" | translate }}:
              </label>

              <div class="col-md-7">
                <mat-form-field appearance="outline" class="w-100 mydomain">
                  <span matPrefix class="ps-2 prefix-text prefixhttp"
                    >https://</span
                  >
                  <input
                    matInput
                    class="subdomain align-middle"
                    name="subdomain"
                    required
                    [(ngModel)]="form.data['subdomain']"
                    (ngModelChange)="onSubdomainChange($event)"
                    placeholder="your-app-name"
                  />
                  <span matSuffix class="suffix-container">
                    <span class="domain-text prefixhttp">{{
                      BASE_DOMAIN
                    }}</span>
                    <button
                      mat-icon-button
                      type="button"
                      (click)="copyUrl()"
                      class="icon-pd-none"
                      matTooltip="{{ 'ALLREMAININGS.Copy_Url' | translate }}"
                      matTooltipPosition="above"
                      [disabled]="
                        form.inputerror['subdomain'] || !form.data['subdomain']
                      "
                      aria-label="Copy URL"
                    >
                      <mat-icon *ngIf="!copied" class="icon-compact"
                        >content_copy</mat-icon
                      >
                      <mat-icon *ngIf="copied" class="icon-compact"
                        >check</mat-icon
                      >
                    </button>
                  </span>
                </mat-form-field>

                <mat-error *ngIf="form.inputerror['subdomain']">
                  {{ form.inputerror["subdomain"] }}
                </mat-error>
              </div>
            </div>

            <!-- Domain Field -->
            <div class="row mb-3 mt-2">
              <label for="domainUrl" class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.DOMAIN" | translate }}:</label
              >
              <div class="col-md-7">
                <mat-form-field appearance="outline" class="w-100 icon-pd-none">
                  <input
                    matInput
                    id="domainUrl"
                    name="domainUrl"
                    type="url"
                    [(ngModel)]="form.data['domainUrl']"
                    [placeholder]="'COMMON.DOMAIN_PLACEHOLDER' | translate"
                  />
                  <mat-icon
                    matSuffix
                    class="icon-compact text-secondary cursor-pointer"
                    [matTooltip]="'COMMON.DOMAIN_TOOLTIP' | translate"
                    matTooltipPosition="above"
                  >
                    info
                  </mat-icon>
                </mat-form-field>
                <mat-error *ngIf="form.inputerror['domainUrl']">
                  {{ form.inputerror["domainUrl"] }}
                </mat-error>
              </div>
            </div>

            <!-- Code Field (Edit Mode) -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <label for="code" class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.CODE" | translate }}:</label
              >
              <div class="col-md-7">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    id="code"
                    name="code"
                    type="text"
                    disabled
                    [(ngModel)]="form.data['code']"
                    [placeholder]="'COMMON.CODE' | translate"
                  />
                </mat-form-field>
              </div>
            </div>

            <!-- Status Field -->
            <div class="row mb-3">
              <label for="status" class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.STATUS" | translate }}:</label
              >
              <div class="col-md-7">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    [(ngModel)]="form.data['status']"
                    id="status"
                    name="status"
                  >
                    <mat-option [value]="undefined" disabled>
                      {{ "COMMON.SELECT" | translate }}
                    </mat-option>
                    <mat-option value="private">
                      {{ "APPLICATIONS.STATUS.PRIVATE" | translate }}
                    </mat-option>
                    <mat-option value="public">
                      {{ "APPLICATIONS.STATUS.PUBLIC" | translate }}
                    </mat-option>
                    <mat-option value="draft">
                      {{ "APPLICATIONS.STATUS.DRAFT" | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <!-- Logo Upload (Edit Mode) -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <label for="logo" class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.LOGO" | translate }}:</label
              >
              <div class="col-md-7">
                <input
                  type="file"
                  #fileInput
                  id="logo"
                  name="logo"
                  accept="image/*"
                  style="display: none"
                  (change)="onFileChanged($event, 'logo', form.data['logo'])"
                />
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    readonly
                    [value]="
                      fileInput.files && fileInput.files.length > 0
                        ? fileInput.files[0].name
                        : ''
                    "
                    (click)="fileInput.click()"
                    placeholder="{{ 'ALLREMAININGS.UPLOAD_LOGO' | translate }}"
                    class="cursor-pointer"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="fileInput.click()"
                    type="button"
                    class="icon-pd-none"
                  >
                    <mat-icon class="text-secondary icon-compact"
                      >attach_file</mat-icon
                    >
                  </button>
                </mat-form-field>
                <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
              </div>
            </div>

            <!-- Logo Preview (Edit Mode) -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <label class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.PREVIEW" | translate }}:</label
              >
              <div class="col-md-7">
                <div class="d-flex align-items-center gap-4">
                  <div class="border rounded-3 p-2">
                    <img
                      [src]="
                        imagePreview['logo'] == null
                          ? getDoc(form.data['logo'])
                          : imagePreview['logo']
                      "
                      [alt]="'COMMON.IMAGE_PREVIEW' | translate"
                      class="img-fluid rounded-2"
                      style="
                        max-width: 150px;
                        max-height: 150px;
                        object-fit: contain;
                      "
                    />
                  </div>
                  <button
                    mat-stroked-button
                    color="warn"
                    type="button"
                    (click)="removeLogo()"
                    [matTooltip]="'ALLREMAININGS.Remove' | translate"
                  >
                    <i class="fa fa-eraser eraser-warn-dark"></i>
                    <span class="ms-2">{{
                      "ALLREMAININGS.Remove" | translate
                    }}</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Enable User Signup (Edit Mode) -->
            <div
              class="row mb-3 align-items-center"
              *ngIf="form.data['id'] > 0"
            >
              <label class="col-md-2 col-form-label fw-medium"
                >{{ "APPLICATIONS.ENABLE_SIGNUP" | translate }}:</label
              >
              <div class="col-md-7 d-flex align-items-center">
                <mat-checkbox
                  id="enableUserSignup"
                  name="enableUserSignup"
                  color="primary"
                  [(ngModel)]="form.data['enableUserSignup']"
                >
                </mat-checkbox>
                <mat-icon
                  class="text-secondary ms-4 cursor-pointer"
                  [matTooltip]="
                    'APPLICATIONS.ENABLE_SIGNUP_TOOLTIP' | translate
                  "
                  matTooltipPosition="above"
                >
                  help_outline
                </mat-icon>
              </div>
            </div>

            <!-- Default Role (If Signup Enabled) -->
            <div
              class="row mb-3"
              *ngIf="form.data['id'] > 0 && form.data['enableUserSignup']"
            >
              <label for="roleId" class="col-md-2 col-form-label fw-medium"
                >{{ "APPLICATIONS.DEFAULT_ROLE" | translate }}:</label
              >
              <div class="col-md-7">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    required
                    id="roleId"
                    name="roleId"
                    [(ngModel)]="form.data['roleId']"
                    placeholder="{{ 'COMMON.SELECT_ROLE' | translate }}"
                  >
                    <mat-option
                      *ngFor="let c of applicationRoles"
                      [value]="c['id']"
                    >
                      {{ c["name"] }}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="!form.data['roleId']">{{
                    "COMMON.ROLE_REQUIRED" | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>

            <!-- Login By Options -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <label class="col-md-2 col-form-label fw-medium"
                >{{ "COMMON.LOGIN_BY" | translate }}:</label
              >
              <div class="col-md-7 d-flex flex-wrap align-items-center gap-4">
                <mat-checkbox
                  id="loginByEmail"
                  name="loginByEmail"
                  color="primary"
                  [(ngModel)]="form.data['loginByEmail']"
                >
                  {{ "APPLICATIONS.LOGIN_BY.EMAIL" | translate }}
                </mat-checkbox>
                <mat-checkbox
                  id="loginByMobileNo"
                  name="loginByMobileNo"
                  color="primary"
                  [(ngModel)]="form.data['loginByMobileNo']"
                >
                  {{ "APPLICATIONS.LOGIN_BY.MOBILE" | translate }}
                </mat-checkbox>
                <mat-checkbox
                  id="loginByLoginCode"
                  name="loginByLoginCode"
                  color="primary"
                  [(ngModel)]="form.data['loginByLoginCode']"
                >
                  {{ "APPLICATIONS.LOGIN_BY.LOGIN_CODE" | translate }}
                </mat-checkbox>
              </div>
            </div>

            <!-- Enable Landing Page (Edit Mode) -->
            <div class="row mb-3" *ngIf="form.data['id'] > 0">
              <label class="col-md-2 col-form-label fw-medium"
                >{{ "APPLICATIONS.ENABLE_LANDING_PAGE" | translate }}:</label
              >
              <div class="col-md-7 d-flex align-items-center">
                <mat-checkbox
                  [(ngModel)]="form.data['showLandingPageUpload']"
                  name="showLandingPageUpload"
                  color="primary"
                  (change)="onLandingPageToggle()"
                >
                </mat-checkbox>
                <mat-icon
                  class="text-secondary ms-3 cursor-pointer"
                  [title]="
                    'APPLICATIONS.ENABLE_LANDINGPAGE_TOOLTIP' | translate
                  "
                >
                  help_outline
                </mat-icon>
              </div>
            </div>

            <!-- Landing Page Upload -->
            <div
              class="row mb-3"
              *ngIf="form.data['showLandingPageUpload'] && form.data['id'] > 0"
            >
              <label for="landingPage" class="col-md-2 col-form-label fw-medium"
                >{{ "APPLICATIONS.UPLOAD_LANDING_PAGE" | translate }}:</label
              >
              <div class="col-md-7">
                <input
                  #landingPageFileInput
                  id="landingPage"
                  type="file"
                  name="landingPage"
                  (change)="
                    landingPageFileInput.files &&
                      uploadLandingpage(
                        $event,
                        'landingPage',
                        form.data['landingPage']
                      )
                  "
                  style="display: none"
                />
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [placeholder]="
                      'APPLICATIONS.UPLOAD_LANDING_PAGE' | translate
                    "
                    [value]="landingPageFileInput.files?.[0]?.name || ''"
                    readonly
                    (click)="landingPageFileInput.click()"
                    class="cursor-pointer"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="landingPageFileInput.click()"
                    class="icon-pd-none"
                  >
                    <mat-icon class="icon-compact">upload_file</mat-icon>
                  </button>
                  <mat-hint>{{
                    "COMMON.FILE_UPLOAD_HINT" | translate
                  }}</mat-hint>
                </mat-form-field>
              </div>
            </div>

            <!-- Landing Page Preview -->
            <div
              class="row mb-3"
              *ngIf="
                form.data['showLandingPageUpload'] &&
                form.data['id'] > 0 &&
                form.data['landingPage']
              "
            >
              <label class="col-md-2 col-form-label fw-medium"></label>
              <div class="col-md-7">
                <a
                  [href]="getDoc(form.data['landingPage'])"
                  target="_blank"
                  class="text-decoration-none"
                >
                  <div
                    class="border rounded-3 p-2 bg-light d-inline-block position-relative"
                  >
                    <img
                      [src]="
                        imagePreview['landingPage'] == null
                          ? getDocThumbnail(form.data['landingPage'])
                          : imagePreview['landingPage']
                      "
                      [alt]="'COMMON.IMAGE_PREVIEW' | translate"
                      class="img-fluid rounded-2"
                      style="
                        max-width: 180px;
                        max-height: 180px;
                        object-fit: contain;
                      "
                    />
                    <span
                      class="position-absolute top-0 end-0 badge m-2"
                      style="background-color: #3f51b5"
                    >
                      <mat-icon
                        class="text-white"
                        style="font-size: 14px; width: 14px; height: 14px"
                        >open_in_new</mat-icon
                      >
                    </span>
                  </div>
                </a>
              </div>
            </div>

            <!-- Full Width Save Button -->
            <div class="row mt-4 pt-3 border-top">
              <div class="col-12 d-flex align-items-center justify-content-end">
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="
                    !uiForm.valid ||
                    appUrlInvalid ||
                    appname ||
                    form.inputerror['subdomain']
                  "
                  (click)="saveData()"
                  [matTooltip]="'COMMON.SAVE' | translate"
                  matTooltipPosition="above"
                  class="py-3 fw-semibold me-md-5"
                >
                  <mat-icon class="me-2">save</mat-icon>
                  <span class="text-uppercase">{{
                    "COMMON.SAVE" | translate
                  }}</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
